import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceNL() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Terug naar App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Algemene Voorwaarden</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Laatst bijgewerkt: {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Bedrijfsinformatie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers wordt beheerd door <span className="font-semibold">Puretech s.r.o.</span>,
                  een <span className="font-semibold">besloten vennootschap met beperkte aansprakelijkheid</span> opgericht onder het recht van <span className="font-semibold">Tsjechië</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Bedrijfsgegevens:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Identificatienummer (IČO):</strong> 05503795</li>
                    <li><strong>BTW-status:</strong> Niet-betaler</li>
                    <li><strong>Kantooradres:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Czechia</li>
                    <li><strong>E-mail:</strong> support@simplestickers.app</li>
                    <li><strong>Website:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Aanvaarding van de Voorwaarden</h2>
              <p className="leading-relaxed">
                Door toegang te krijgen tot en gebruik te maken van Simple Stickers ("de Dienst"), accepteert u en gaat u akkoord met de voorwaarden van deze overeenkomst. Als u niet akkoord gaat met het bovenstaande, gebruik deze dienst dan niet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Beschrijving van de Dienst</h2>
              <p className="leading-relaxed">
                Simple Stickers is een taak- en projectmanagementapplicatie die gebruikers tools biedt om sticky notes te organiseren met behulp van een Kanban-bord systeem. De dienst omvat zowel gratis als premium niveaus met verschillende functies en gebruikslimieten.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Gebruikersaccounts</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  U bent verantwoordelijk voor het handhaven van de vertrouwelijkheid van uw account en wachtwoord en voor het beperken van toegang tot uw computer. U gaat ermee akkoord de verantwoordelijkheid te aanvaarden voor alle activiteiten die plaatsvinden onder uw account of wachtwoord.
                </p>
                <p className="leading-relaxed">
                  U moet nauwkeurige en volledige informatie verstrekken bij het aanmaken van uw account en deze informatie up-to-date houden.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Abonnement en Betalingsvoorwaarden</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Gratis Niveau:</strong> Inclusief toegang tot basisfuncties met beperkingen op het aantal sticky notes (50) en AI-suggesties (10 per dag).
                </p>
                <p className="leading-relaxed">
                  <strong>Premium Niveau:</strong> Beschikbaar voor $48 per jaar, inclusief verhoogde limieten (1000 sticky notes, 100 AI-suggesties per dag) en extra functies zoals mogelijkheden om sticky notes te delen.
                </p>
                <p className="leading-relaxed">
                  Betalingsverwerking wordt afgehandeld door Polar. Abonnementen worden automatisch verlengd tenzij opgezegd. U kunt uw abonnement op elk moment opzeggen via uw accountinstellingen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Aanvaardbaar Gebruik</h2>
              <p className="leading-relaxed">
                U gaat ermee akkoord de dienst niet te gebruiken voor het opslaan, verzenden of verspreiden van inhoud die illegaal, schadelijk, bedreigend, beledigend, intimiderend, lasterlijk, vulgair, obsceen of anderszins aanstootgevend is. U gaat er ook mee akkoord de dienst niet te verstoren of te proberen toegang te krijgen tot accounts van anderen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacy en Bescherming van Persoonsgegevens</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Uw privacy is belangrijk voor ons. Voor details over hoe we uw persoonlijke informatie verzamelen, gebruiken en beschermen, zie ons <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Privacybeleid</a>.
                </p>
                <p className="leading-relaxed">
                  Door gebruik te maken van deze dienst, gaat u ook akkoord met ons Privacybeleid en de verwerking van uw persoonsgegevens in overeenstemming met de AVG en toepasselijke wetgeving inzake gegevensbescherming.
                </p>
                <p className="leading-relaxed">
                  Om uw rechten onder de AVG uit te oefenen of voor vragen over gegevensbescherming, neem contact met ons op via <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Beschikbaarheid van de Dienst en Ondersteuning</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Beschikbaarheid van de Dienst:</strong> We streven naar maximale beschikbaarheid van de dienst en betrouwbare werking. In geval van ongeplande storingen werken we aan een snelle oplossing. De dienst wordt geleverd "zoals die is" zonder formele beschikbaarheidsgaranties.
                </p>
                <p className="leading-relaxed">
                  <strong>Onderhoud:</strong> Om veiligheid en stabiliteit te waarborgen, kunnen we doorlopend onderhoud aan de dienst uitvoeren. We streven ernaar gepland onderhoud in te plannen tijdens periodes met weinig gebruik en vooraf te informeren waar mogelijk. In urgente gevallen (bijv. beveiligingspatches) kan onderhoud plaatsvinden zonder voorafgaande kennisgeving.
                </p>
                <p className="leading-relaxed">
                  <strong>Ondersteuning:</strong> We bieden technische ondersteuning via e-mail op support@simplestickers.app. We streven ernaar zo snel mogelijk te reageren, maar specifieke reactietijden worden niet gegarandeerd.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Restitutiebeleid</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>30 Dagen Niet-Goed-Geld-Terug Garantie:</strong> Als u niet tevreden bent met de premium dienst, kunt u binnen 30 dagen na uw eerste aankoop een volledige terugbetaling aanvragen. Na 30 dagen zijn alle betalingen definitief en niet-restitueerbaar.
                </p>
                <p className="leading-relaxed">
                  <strong>Factureringsfouten:</strong> Als u denkt dat u onjuist bent gefactureerd, neem dan binnen 30 dagen na de afschrijving contact met ons op via support@simplestickers.app.
                </p>
                <p className="leading-relaxed">
                  <strong>Verwerking van Restituties:</strong> Goedgekeurde restituties worden binnen 10-14 werkdagen verwerkt naar de oorspronkelijke betaalmethode. We behouden ons het recht voor om restitutieverzoeken naar eigen goeddunken goed te keuren of af te wijzen.
                </p>
                <p className="text-sm text-gray-600">
                  Opmerking: Opzeggingen van abonnementen resulteren niet automatisch in restituties. U moet expliciet een restitutie aanvragen binnen de periode van 30 dagen.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Leeftijdsbeperkingen en Geschiktheid</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Minimumleeftijd:</strong> U moet minimaal 16 jaar oud zijn om deze dienst te gebruiken.
                </p>
                <p className="leading-relaxed">
                  <strong>Ouderlijke Toestemming:</strong> Gebruikers onder de 18 jaar moeten toestemming van een ouder of voogd hebben om de dienst te gebruiken.
                </p>
                <p className="leading-relaxed">
                  <strong>Zakelijke Gebruikers:</strong> Zakelijke accounts vereisen dat de gebruiker bevoegd is om de organisatie te binden.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Toepasselijk Recht en Rechtsmacht</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Deze Voorwaarden worden beheerst door en geïnterpreteerd in overeenstemming met de wetten van de Tsjechische Republiek, zonder rekening te houden met bepalingen inzake wetsconflicten.
                </p>
                <p className="leading-relaxed">
                  Alle geschillen die voortvloeien uit deze Voorwaarden of uw gebruik van de Dienst vallen onder de exclusieve bevoegdheid van de rechtbanken van de Tsjechische Republiek.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Contentmoderatie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  We behouden ons het recht voor om inhoud te verwijderen, te wijzigen of te weigeren weer te geven die deze Voorwaarden schendt of die we naar eigen goeddunken ongepast achten.
                </p>
                <p className="leading-relaxed">
                  Als u denkt dat inhoud moet worden beoordeeld, neem dan contact met ons op via support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Intellectueel Eigendom</h2>
              <p className="leading-relaxed">
                De dienst en de oorspronkelijke inhoud, functies en functionaliteit zijn eigendom van Simple Stickers en worden beschermd door internationale auteursrechten, handelsmerken, patenten, handelsgeheimen en andere intellectuele eigendomsrechten.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Beperking van Aansprakelijkheid</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Voor zover maximaal toegestaan door de toepasselijke wetgeving, is Simple Stickers niet aansprakelijk voor enige indirecte, incidentele, speciale, gevolgschade of punitieve schade, inclusief maar niet beperkt tot verlies van winst, gegevens, gebruik, goodwill of andere immateriële verliezen, voortvloeiend uit uw gebruik van de dienst.
                </p>
                <p className="leading-relaxed">
                  Deze beperking van aansprakelijkheid is niet van toepassing op schade veroorzaakt door opzettelijk wangedrag of grove nalatigheid, of zoals anderszins verboden door de toepasselijke wetgeving.
                </p>
                <p className="leading-relaxed">
                  Onze totale aansprakelijkheid jegens u voor claims die voortvloeien uit uw gebruik van de dienst zal niet hoger zijn dan het bedrag dat u ons heeft betaald in de 12 maanden voorafgaand aan de claim, of €100, afhankelijk van welk bedrag hoger is.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Beëindiging</h2>
              <p className="leading-relaxed">
                We kunnen uw account beëindigen of opschorten en de toegang tot de dienst onmiddellijk blokkeren, zonder voorafgaande kennisgeving of aansprakelijkheid, naar eigen goeddunken, om welke reden dan ook, inclusief maar niet beperkt tot wanneer u de Voorwaarden schendt.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Wijzigingen in de Voorwaarden</h2>
              <p className="leading-relaxed">
                We behouden ons het recht voor om deze Voorwaarden op elk moment te wijzigen of te vervangen. Als een wijziging materieel is, zullen we ten minste 30 dagen van tevoren kennisgeving geven voordat nieuwe voorwaarden van kracht worden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Contactgegevens</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Als u vragen heeft over deze Algemene Voorwaarden, neem dan contact met ons op:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-mail:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Voor alle vragen met betrekking tot ondersteuning, juridische zaken, privacy, gegevensbescherming en zakelijke vragen
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
